import QuotesHome from "./QuotesHome";
import { QuoteForm } from "@/modules/quotes";
import QuoteNew from "./QuoteNew";
import QuoteInformation from "./QuoteInformation";
import QuoteEditWrapper from "./QuoteEditWrapper";
import QuoteDocuments from "./QuoteDocuments";
import QuoteOverview from "./QuoteOverview";
import QuoteProgram from "@/modules/quotes/components/program/QuoteProgram";

import MainInfo from "./subview/MainInfo";
import AllDays from "./subview/AllDays";

export default [
  {
    path: "/quotes",
    name: "quotes",
    component: QuotesHome,
    meta: {
      tabAccess: "QUOTES",
    },
  },
  {
    path: "/quotes_new",
    name: "quotes_new",
    component: QuoteNew,
    meta: {
      tabAccess: "QUOTES",
    },
  },
  {
    path: "/quotes_view/:quote_id",
    component: QuoteEditWrapper,
    children: [
      {
        path: "",
        name: "quotes_view",
        component: QuoteInformation,
        meta: {
          tabAccess: "QUOTES",
        },
      },
      {
        path: "documents",
        name: "quotes_documents",
        component: QuoteDocuments,
        meta: {
          tabAccess: "QUOTES",
        },
      },
      {
        path: "overview",
        name: "quotes_overview",
        component: QuoteOverview,
        meta: {
          tabAccess: "QUOTES",
        },
      },
      {
        path: "program",
        name: "quotes_program",
        component: QuoteProgram,
        meta: {
          tabAccess: "QUOTES",
        },
      },
    ],
  },
];
